import fr from './fr.json'

export default {
  fr,
}
